import './badge.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Badge = forwardRef((props, ref) => {
  const className = classNames({
    badge: true,
    [`badge-${props.type}`]: true,
    [`badge-${props.size}`]: props.size,
    'badge-pill': props.pill,
    [props.className]: props.className,
  });

  return (
    <span ref={ref} className={className}>
      {props.children}
    </span>
  );
});

Badge.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'primary', 'secondary', 'warning', 'danger']),
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
  pill: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Badge.defaultProps = {
  type: 'default',
  pill: false,
};

export default Badge;
